import { heroStats, tickerItems } from '@/mocks/homeMock';

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dynamic%20abstract%20composition%20of%20light%20streaks%20and%20racing%20speed%20lines%20in%20warm%20coral%2C%20orange%20and%20cream%2C%20editorial%20cover%20art%2C%20high%20energy%2C%20soft%20gradient%20depth&width=1600&height=900&seq=hero-speed-2026&orientation=landscape"
          alt="吃瓜最快 全网热点竞速首发封面"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/80 via-background-900/55 to-background-50" />
      </div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-col items-center px-4 pb-16 pt-28 text-center md:px-6 md:pb-24 md:pt-36">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/10 px-4 py-1.5 text-xs font-semibold text-accent-100 ring-1 ring-accent-200/40 backdrop-blur">
          <i className="ri-timer-flash-line text-sm" />
          全网热点 · 分钟级抢先
        </span>

        <h1 className="mt-6 max-w-4xl font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
          全网吃瓜，我<span className="text-accent-400">最快</span>
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-100/90 md:text-lg">
          实时对比各大平台的爆料时效与内容深度，从突发新闻到深度盘点，
          抢先前排、时效比拼、速度排行一网打尽，帮你用最少时间掌握最全瓜料。
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#hot"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition hover:bg-primary-400"
          >
            查看今日热榜
            <i className="ri-arrow-down-line" />
          </a>
          <a
            href="#speed"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50/10 px-6 py-3 text-sm font-bold text-background-50 ring-1 ring-background-50/30 backdrop-blur transition hover:bg-background-50/20"
          >
            <i className="ri-scales-3-line" />
            对比平台速度
          </a>
        </div>

        <dl className="mt-10 grid w-full grid-cols-2 gap-3 sm:grid-cols-4">
          {heroStats.map((s) => (
            <div key={s.label} className="rounded-2xl bg-background-50/10 px-3 py-4 backdrop-blur ring-1 ring-background-50/15">
              <dt className="font-heading text-2xl font-black text-accent-300 md:text-3xl">{s.value}</dt>
              <dd className="mt-1 text-xs text-background-100/80">{s.label}</dd>
            </div>
          ))}
        </dl>
      </div>

      <div className="relative border-t border-background-200 bg-background-50">
        <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 py-2.5 md:px-6">
          <span className="inline-flex shrink-0 items-center gap-1.5 text-xs font-bold text-primary-600">
            <i className="ri-fire-fill text-accent-500" />
            实时快讯
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex w-max animate-ticker whitespace-nowrap">
              {[...tickerItems, ...tickerItems].map((t, i) => (
                <span key={i} className="mx-6 inline-flex items-center gap-2 text-sm text-foreground-700">
                  <span className="h-1 w-1 rounded-full bg-accent-400" />
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}